import { FormControl } from '@angular/forms';
import { IDropdownOption } from '../../../../shared/components/mat-dropdown/mat-dropdown.component';

export enum EAiProviderType {
  gemini = 'gemini',
}

export const AI_INSTRUCTIONS_MAX_LENGTH = 10000;

export interface IAiProvider {
  id: number;
  instructions: string | null;
  isActive: boolean;
  name: string;
  providerType: EAiProviderType;
}

// Write-only: the API never returns credentials.
export interface IAiProviderCredentials {
  apiKey: string;
}

export type TAddAiProvider = Omit<IAiProvider, 'id'> & { credentials: IAiProviderCredentials };

// The provider type cannot change after creation; credentials are sent only when they should be replaced.
export type TEditAiProviderDto = Omit<IAiProvider, 'id' | 'providerType'> & { credentials?: IAiProviderCredentials };

export interface IEditAiProvider {
  dto: TEditAiProviderDto;
  id: number;
}

export type TFormControlAiProvider = {
  apiKey: FormControl<string | null>;
  instructions: FormControl<string | null>;
  isActive: FormControl<boolean | null>;
  name: FormControl<string | null>;
  providerType: FormControl<IDropdownOption<EAiProviderType>[] | null>;
};

export type TFormAiProvider = {
  apiKey: string | null;
  instructions: string | null;
  isActive: boolean;
  name: string;
  providerType: IDropdownOption<EAiProviderType>[];
};
